import { render, staticRenderFns } from "./InviteCodePanel.vue?vue&type=template&id=496f8fad&scoped=true"
import script from "./InviteCodePanel.vue?vue&type=script&lang=js"
export * from "./InviteCodePanel.vue?vue&type=script&lang=js"
import style0 from "./InviteCodePanel.vue?vue&type=style&index=0&id=496f8fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f8fad",
  null
  
)

export default component.exports